import { useEffect, useState } from "react";
import { Download, Trash2, Mail } from "lucide-react";
import { api, API } from "@/lib/api";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/leads").then(setLeads).catch(() => setLeads([]));
  useEffect(() => { load(); }, []);

  const toggle = async (l, key) => {
    await api.put(`/admin/leads/${l.id}`, { [key]: !l[key] });
    load();
  };

  const del = async (id) => {
    if (!window.confirm("¿Eliminar este lead?")) return;
    await api.delete(`/admin/leads/${id}`);
    load();
  };

  const exportCsv = async () => {
    const token = localStorage.getItem("influcas_token");
    const r = await fetch(`${API}/admin/leads/export.csv`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "leads.csv"; a.click(); URL.revokeObjectURL(url);
  };

  const filtered = filter === "unread" ? leads.filter((l) => !l.read) : filter === "contacted" ? leads.filter((l) => l.contacted) : leads;

  return (
    <div data-testid="admin-leads">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display text-4xl font-black tracking-tighter mb-1">Leads</h1>
          <p className="text-sm text-muted-foreground">Total: {leads.length} · No leídos: {leads.filter((l) => !l.read).length}</p>
        </div>
        <button onClick={exportCsv} data-testid="export-leads" className="inline-flex items-center gap-2 px-5 py-2.5 border border-border rounded-sm font-semibold text-sm hover:border-primary"><Download className="w-4 h-4" /> Exportar CSV</button>
      </div>

      <div className="flex gap-2 mb-6">
        {[["all", "Todos"], ["unread", "No leídos"], ["contacted", "Contactados"]].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} className={`px-4 py-2 rounded-sm text-sm font-semibold border ${filter === k ? "bg-primary text-primary-foreground border-primary" : "border-border"}`}>{l}</button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered.map((l) => (
          <div key={l.id} className={`border rounded-sm p-5 ${l.read ? "border-border" : "border-primary"}`} data-testid={`lead-${l.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div>
                <span className="font-bold text-lg">{l.name}</span>
                <span className="ml-3 text-xs text-muted-foreground">{l.email} · {l.whatsapp}</span>
              </div>
              <span className="text-xs text-muted-foreground">{new Date(l.created_at).toLocaleString()}</span>
            </div>
            <div className="text-xs text-muted-foreground mb-2">
              <strong>{l.company || "—"}</strong> · {l.city || "—"} · {l.interest} · {l.budget}
            </div>
            {l.message && <p className="text-sm bg-secondary/40 p-3 rounded-sm mb-3 whitespace-pre-wrap">{l.message}</p>}
            <div className="flex gap-2">
              <button onClick={() => toggle(l, "read")} className="px-3 py-1.5 text-xs border border-border rounded-sm font-semibold inline-flex items-center gap-1"><Mail className="w-3 h-3" /> {l.read ? "Marcar no leído" : "Marcar leído"}</button>
              <button onClick={() => toggle(l, "contacted")} className="px-3 py-1.5 text-xs border border-border rounded-sm font-semibold">{l.contacted ? "Sin contactar" : "Marcar contactado"}</button>
              <button onClick={() => del(l.id)} className="px-3 py-1.5 text-xs border border-destructive/40 text-destructive rounded-sm font-semibold inline-flex items-center gap-1"><Trash2 className="w-3 h-3" /> Eliminar</button>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="text-center text-muted-foreground py-12">Sin leads.</p>}
      </div>
    </div>
  );
}
